import { Link } from 'react-router-dom';
import PageHeader from '@/components/Layout/PageHeader.jsx';
import { Card, CardContent } from '@/components/ui/card.jsx';

export default function TesoreriaPlaceholder({ title, category, backTo = '/tesoreria' }) {
  const breadcrumbs = [
    { label: 'Tesorería', href: '/tesoreria' },
    ...(category ? [{ label: category }] : []),
    { label: title },
  ];

  return (
    <div className="mx-auto w-full max-w-[1400px] px-6 py-6">
      <PageHeader
        title={title}
        subtitle="Pantalla en construcción. Estamos preparando esta funcionalidad para el módulo de Tesorería."
        breadcrumbs={breadcrumbs}
        actions={
          <Link
            to={backTo}
            className="inline-flex items-center justify-center rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.9)] px-4 py-2 text-sm font-semibold text-[rgb(var(--fg))] shadow-[var(--shadow)] transition hover:border-[rgba(var(--brand),0.45)] hover:text-[rgb(var(--brand-700))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Volver
          </Link>
        }
      />
      <Card className="rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.95)] shadow-[var(--shadow)]">
        <CardContent className="space-y-3 text-sm text-[rgb(var(--muted))]">
          <p className="text-base font-semibold text-[rgb(var(--fg))]">En construcción</p>
          <p>
            Esta vista estará disponible próximamente con el flujo completo de gestión y seguimiento en
            Tesorería.
          </p>
          <p>
            Mientras tanto podés continuar navegando desde el módulo de Tesorería o regresar al tablero
            principal.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
